// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f23c2817","453":"73fd639a","732":"c2fa909f"}[chunkId] + ".chunk.js";
};